import { FC } from 'react';

import { twMerge } from 'tailwind-merge';

import { Typography } from '../../typography';

const tagTextVariants = {
  default: {
    variant: '16-r',
    className: 'text-base-500',
  },
  sm: {
    variant: '14-r',
    className: 'text-base-100',
  },
  xs: {
    variant: '14-m',
    className: 'text-base-500',
  },
};

export const Soon: FC<{
  size?: 'sm' | 'default' | 'xs';
  className?: string;
  text?: string;
}> = ({ className, text, size = 'default' }) => {
  return (
    <div
      className={twMerge(
        'h-fit cursor-default rounded-[20px] bg-base-300 px-4 py-2',
        className,
      )}
    >
      <Typography
        variant={tagTextVariants[size].variant}
        className={tagTextVariants[size].className}
      >
        {text || 'Soon'}
      </Typography>
    </div>
  );
};
